export const getLineItemsToReturn = items => {
  const lineItems = items?.map(item => ({
    ...item,
    exchange_info: null,
    cancelled_from_draft: false,
  }))

  return lineItems
}
